import { mdiLightbulbOutline } from '@mdi/js';
import { useLocation, useNavigate } from 'react-router';
import Typography from '@mui/material/Typography';

import { ISkillListItemFragment } from 'graphql/types';
import { TableCell, TableRowMedia } from 'common/components/Table';
import { Icon } from 'common/components/Icon';
import { ItemMedia } from 'common/components/ItemMedia';
import { getUrl } from 'route/utils/getUrl';
import { Checkbox } from 'common/components/Checkbox';

interface IProps {
    isSelected: boolean;
    skill: ISkillListItemFragment;
    onSelect?: () => void;
}

export const SkillsManagementTableRow = ({
    isSelected,
    skill,
    onSelect,
}: IProps) => {
    const navigate = useNavigate();
    const location = useLocation();

    const { id, name, shortName, thumbnail } = skill;

    return (
        <TableRowMedia
            hover
            key={id}
            sx={{ cursor: 'pointer' }}
            onClick={() => {
                const searchParams = new URLSearchParams(location.search);
                const url = `${getUrl('SKILL_EDIT', { id })}?${searchParams}`;

                navigate(url);
            }}
        >
            <TableCell>
                <Checkbox
                    checked={isSelected}
                    onClick={(e) => {
                        onSelect?.();

                        e.stopPropagation();
                    }}
                />
            </TableCell>

            <TableCell sx={{ width: '1px' }}>
                <ItemMedia
                    color="primary"
                    image={thumbnail?.url || ''}
                    size="small"
                >
                    <Icon
                        path={mdiLightbulbOutline}
                        size="2rem"
                        sizeSm="3rem"
                    />
                </ItemMedia>
            </TableCell>
            <TableCell>
                {name}{' '}
                <Typography
                    color="text.secondary"
                    sx={{ fontSize: '1.4rem' }}
                    variant="body2"
                >
                    {shortName}
                </Typography>
            </TableCell>
        </TableRowMedia>
    );
};
